import React from 'react';

import DefaultLogosFooter from './DefaultLogosFooter';
import { useTrans } from 'utils/localisation';
import { observer } from 'store';

import * as styles from './AsideFooter.module.scss';

function AsideFooter() {
  const t = useTrans(['getConsultation']);

  return (
    <section className={styles.wrapper}>
      <DefaultLogosFooter title={t('clientsWhoTrustUs')} />
    </section>
  );
}

export default observer(AsideFooter);
